import React from "react";

export default function WelcomeComponent(){
    return(
   <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: 400 }}
            >
              <div className="position-relative h-100">
                <img
                  className="img-fluid position-absolute w-100 h-100"
                  src='/assets/img/about.JPG'
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h6 className="section-title bg-white text-start text-primary pe-3">
                Welcome to the outpost
              </h6>
            
              <p className="mb-4">
                The Outpost is guided by deep industry expertise and a passion for well-crafted
                travel. With David’s background as a Fora Travel Advisor, each experience is
                thoughtfully curated with insider knowledge, trusted partners, and attention
                to every detail.
              </p>

              <p className="mb-4">
                Complementing this, Jarrod brings global hospitality and venue-sourcing expertise
                from his work at HelmsBriscoe, ensuring every stay is seamlessly negotiated,
                strategically planned, and effortlessly executed from start to finish.
              </p>

              <div className="row gy-2 gx-4 mb-4">
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Hotels
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Cruises
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Day & Multiday Tours
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Vacation Packages
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Flights
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                     Ground Transportation
                  </p>
                </div>
              </div>
              <a className="btn btn-primary py-3 px-5 mt-2" href="/about">
                Meet The Outpost Gentlemen
              </a>
            </div>
          </div>
        </div>
      </div>)
}